import commonFiles from '@/store/common-modules/files';

export default {
  namespaced: true,
  modules: {
    commonFiles,
  },
};
